import { render, staticRenderFns } from "./Param.vue?vue&type=template&id=b127adde&scoped=true&"
import script from "./Param.vue?vue&type=script&lang=js&"
export * from "./Param.vue?vue&type=script&lang=js&"
import style0 from "./Param.vue?vue&type=style&index=0&id=b127adde&lang=scss&scoped=true&"
import style1 from "./Param.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b127adde",
  null
  
)

export default component.exports